/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const deliveryMode = {
  setDeliveryMode: {
    unknownError: 'Se ha producido un error desconocido. Póngase en contacto con el servicio de asistencia.',
  },
};
